module.exports = __webpack_public_path__ + "img/NoMatch.961dace6.svg";